<template>
  <div class="def-data-item" :style="{ backgroundColor: bgColor }">
    <div class="item-left">
      <div v-if="$slots.icon" class="icon-wrapper">
        <slot name="icon"></slot>
      </div>
      <span class="label" :title="label" v-if="label" :style="{ width: labelWidth }">{{ label }}</span>
    </div>
    <div class="item-right">
      <div class="value-container">
        <div class="status-dot" :class="{ 'bg-green': status === 'success', 'bg-red': status === 'error' }" v-if="status"></div>
        <slot name="value">
            <span class="value-text" :title="value">{{ value }}</span>
        </slot>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  label: String,
  value: [String, Number],
  bgColor: {
    type: String,
    default: 'transparent'
  },
  status: String,
  labelWidth: String
})
</script>

<style scoped lang="scss">
.def-data-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  border-radius: 4px;
  align-items: center;
  
  // --bg-color: #F5F5FE;
  // @media (prefers-color-scheme: dark) {
  //   --bg-color: #3c3c3c;
  // }
}

.item-left {
  display: flex;
  align-items: center;
  flex: 1;
}

.icon-wrapper {
  width: 16px;
  height: 16px;
  padding: 4px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: content-box;
}

.label {
  color: #666; 
  margin-left: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 14px;
}

.item-right {
  display: flex;
  align-items: center;
  margin-left: 8px;
  flex: 1;
  justify-content: flex-end;
}

.value-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: right;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 8px;
  
  &.bg-green {
    background-color: #22C55E; // green-500
  }
  
  &.bg-red {
    background-color: #EF4444; // red-500
  }
}

.value-text {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  text-align: right;
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 14px;
  color: #333;
}
</style>
